<template>
  <div
    :class="{
      'form-group--error': typeof validate !== 'undefined' && validate.$error,
      'form-group': hasGroup,
    }"
  >
    <label v-if="labelShown" :for="id">
      {{ label }}
      <span class="text-danger" v-if="isRequired"> * </span>
    </label>

    <Dropdown
      :id="id"
      ref="field"
      :disabled="disabled"
      :placeholder="placeholder"
      v-model="inputValue"
      :class="[
        {
          'p-invalid': typeof validate !== 'undefined' && validate.$error,
        },
        inputClass,
        'form-control',
      ]"
      :autofocus="autofocus"
      :options="options"
      :optionLabel="optionLabel"
      :optionValue="optionValue"
      :showClear="showClear"
      :filter="filter"
      :appendTo="appendTo"
      :filterPlaceholder="filterPlaceholder"
      @change="$emit('change', $event)"
      :dataKey="dataKey"
    />

    <BaseFormMessage
      v-if="typeof validate !== 'undefined'"
      :validate="validate"
      :label="label"
    />
  </div>
</template>

<script>
import Dropdown from "primevue/dropdown";

export default {
  components: {
    Dropdown,
  },
  props: {
    id: {
      type: String,
      default: "",
    },
    //Dropdown label
    label: {
      type: String,
    },
    // Dropdown reactive value
    value: {
      type: [String, Object, Array, Number],
      default: "",
    },
    // Dropdown placeholder
    placeholder: {
      type: String,
      default: "Please Select",
    },
    isRequired: {
      type: Boolean,
      default: false,
    },
    inputClass: {
      type: String,
      required: false,
    },

    // Dropdown disabled state
    disabled: {
      type: Boolean,
      default: false,
    },
    // Dropdown autofocus state
    autofocus: {
      type: Boolean,
      default: false,
    },
    //Dropdown options
    options: {
      type: Array,
      default: null,
    },

    //Dropdown option label
    optionLabel: {
      type: String,
      default: null,
    },
    //Dropdown option value
    optionValue: {
      type: String,
      default: null,
    },
    //Dropdown option diabled
    optionDisabled: {
      type: String,
      default: null,
    },
    //Dropdown show clear icon
    showClear: {
      type: Boolean,
      default: false,
    },
    //Dropdown show filter
    filter: {
      type: Boolean,
      default: false,
    },
    appendTo: {
      type: String,
      default: "",
    },
    //Dropdown filter placeholder
    filterPlaceholder: {
      type: String,
      default: null,
    },
    //Dropdown display (chip or comma)
    display: {
      type: String,
      default: "comma",
    },
    validate: {
      type: Object,
      default: () => {
        // This is intentional
      },
    },

    hasGroup: {
      type: Boolean,
      default: true,
    },

    dataKey: {
      type: String,
      required: true,
    },
    labelShown: {
      type: Boolean,
      default: false,
    },
  },
  computed: {
    inputValue: {
      get: function () {
        return this.value;
      },
      set: function (newValue) {
        this.$emit("input", newValue);
      },
    },
  },
};
</script>
